import { Admin, CustomRoutes, Resource } from 'react-admin'
import { Route } from 'react-router-dom'
import styles from './MultiPage.module.scss'

import theme from '../styles/Theme.tsx'
import Dashboard from './Dashboard/Dashboard.tsx'

import PersonOutlineIcon from '@mui/icons-material/PersonOutline'

// component imports
import learners from '@src/pages/Learner/index'
import users from '@src/pages/User/index'
import activities from '@src/pages/Activities/index'
import groupCurriculums from '@src/pages/GroupCurriculums/index'
import analytics from '@src/pages/Analytics/index'
import adminAccounts from '@src/pages/Admin/Accounts/index'
import adminRobots from '@src/pages/Admin/Robots/index'
import adminSubscriptions from '@src/pages/Admin/Subscriptions/index'
import accounts from '@src/pages/Accounts/index'
import AccountSettingsForm from './Accounts/Settings/AccountSettingsForm.tsx'

import LxLayout from './layout/Layout.tsx'
import { useTokenManagement } from '@logic/contexts/AppStore/useTokenManagement.ts'
import { AppProviders } from '@logic/contexts/AppProviders.tsx'

import { ActivityReportProvider } from '@logic/contexts/Learners/ActivityReport/LearnerActivityReportContext.tsx'
import { LearnerActivityReport } from '@src/pages/Learner/Show/Activities/activityReport/LearnerActivityReport.tsx'

import { AnalyticsReport } from '@src/pages/Analytics/Reports/AnalyticsReport.tsx'
import { AuditLog } from '@src/pages/Accounts/AuditLogs/LogList.tsx'
import {AccountUsers} from "@src/pages/Accounts/User/AccountUsers.tsx";

import { UserShowProvider } from '@logic/contexts/Users/UserShowContext.tsx'

import { AccountSelectionDialog } from './AccountSelection'

import { CircularProgress } from '@mui/material'
import { isNilOrEmpty } from '@src/utils/isNilOrEmpty.ts'
import { UserLearners } from '@src/pages/User/Show/Learners/UserLearners.tsx'
import SessionTimeout from './Generic/SessionTimeout.tsx'

const Home = () => {
  const { dataProvider, selectAccountDialogOpen, accounts: userAccounts, userId, handleAccountSelection } = useTokenManagement()

  if (selectAccountDialogOpen) {
    return <AccountSelectionDialog selectAccountDialogOpen={selectAccountDialogOpen} userAccounts={userAccounts} handleAccountSelection={handleAccountSelection} />
  }

  if (isNilOrEmpty(dataProvider) || isNilOrEmpty(userId)) {
    return (
      <div className={styles.homePageLoader}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <AppProviders dataProvider={dataProvider} userId={userId}>
      <Admin
        theme={theme}
        // i18nProvider={I18nProvider}
        layout={LxLayout}
        dashboard={Dashboard}
        dataProvider={dataProvider}
      >
        <Resource name='Learner' list={learners.list} show={learners.show} create={learners.create} />
        <Resource name='CurriculumView' list={activities.list} show={activities.show} />
        <Resource name='GroupCurriculums' list={groupCurriculums.list} />
        <Resource
          name='User'
          list={users.list}
          create={users.create}
          edit={users.edit}
          // show={users.show} // TODO that can be probably can be easly removed
          icon={PersonOutlineIcon}
        >
          <Route
            path=':id/show/learners'
            element={
              <UserShowProvider>
                <UserLearners />
              </UserShowProvider>
            }
          />
        </Resource>
        <Resource name='Analytics' list={analytics.list}>
          <Route path=':accountId/report' element={<AnalyticsReport />} />
          
        </Resource>
        <Resource name='AdminAccounts' list={adminAccounts.list} create={adminAccounts.create} />
        <Resource name='AdminRobots' list={adminRobots.list} />
        <Resource name='AdminSubscriptions' list={adminSubscriptions.list} create={adminSubscriptions.create} />
        <Resource name='Accounts' list={accounts.list} >
          <Route path=':accountId/auditLogs' element={<AuditLog />} />
          <Route path=':accountId/users' element={<AccountUsers />} />
        </Resource>
        {/* Custom Routes */}
        <CustomRoutes>
          <Route
            path={'/Learner/:id/show/activity/:activityId/report'}
            element={
              <ActivityReportProvider>
                <LearnerActivityReport />
              </ActivityReportProvider>
            }
          />
          <Route path={'/AdminAccounts/combined'} element={<adminAccounts.combined />} />
          <Route path={'/AccountSettings'} element={<AccountSettingsForm />} />
        </CustomRoutes>
      </Admin>
      {userId && <SessionTimeout userId={userId} />}
    </AppProviders>
  )
}

export default Home
